var React = require('react');

function BgPageBannerV2BottomMobileInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#2c4965","d":"M0,0V14.65L158.75,76.51c9.11,3.53,19.93,9.6,31.79,10.59h7.67c12.25-1,25.22-7,34.37-10.53L414,6.37V0Z"}));
}

BgPageBannerV2BottomMobileInline.defaultProps = {"aria-hidden":"true","data-name":"Calque 1","viewBox":"0 0 414 87.1"};

module.exports = BgPageBannerV2BottomMobileInline;

BgPageBannerV2BottomMobileInline.default = BgPageBannerV2BottomMobileInline;
